import { Dialog } from "components/ui/Dialog/Dialog";
import { PATIENT_FIELD_ORDER } from "features/cdm/utils/pcrsDetails";

import { DetailSection } from "./components/DetailSection/DetailSection";
import styles from "./PcrsDetailsDialog.module.css";

export const PcrsDetailsDialog = ({
  open,
  onClose,
  schemeCheck,
  patientDetails,
  isPatientDetailsLoading = false,
}) => {
  return (
    <Dialog open={open} onClose={onClose} title="PCRS Check" width={960}>
      <div className={styles.body}>
        {isPatientDetailsLoading ? (
          // The cdm-ws details lag behind the scheme check — wait for them before
          // rendering, so the dialog never briefly shows "details not returned".
          <p className={styles.loading}>Loading PCRS details…</p>
        ) : (
          <>
            <DetailSection
              title="Scheme"
              source={schemeCheck}
              emptyText="The PCRS scheme check has not returned any data."
            />
            <DetailSection
              title="Patient"
              source={patientDetails}
              order={PATIENT_FIELD_ORDER}
              emptyText="PCRS patient details have not been returned for this patient."
            />
          </>
        )}
      </div>
    </Dialog>
  );
};